import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import image1 from "../../../../shared/resources/ieee-mb-tagline-white.png";
import image2 from "../../../../shared/resources/in-flat-white.png";

const SidePanel = () => {
  return (
    <Container
      className="m-2 "
      style={{
        paddingLeft: "60px",
        paddingTop: "50px",
        paddingRight: "60px",
        paddingBottom: "0px",
      }}
    >
      <Row>
        <Col xs={12} className="p-0" style={{ height: "30%" }}>
          <h1 className="color-white" style={{ fontSize: "2.5vw" }}>
            IEEE <br />
            Innovation Nation
          </h1>
        </Col>
      </Row>
      <Row className="pt-3" style={{ height: "60%" }}>
        <Col xs={12} className="p-0">
          <p className="text-justify color-white" style={{ fontSize: "1.1vw" }}>
            We help you work through your business model hand in hand with
            expert advice rounded out with Hands-on support and coaching
            mentorship from our awesome and dedicated mentors and connect you to
            the right people to finance and accelerate your startup growth.
          </p>
        </Col>
      </Row>
      <Row style={{ height: "10%" }}>
        <Col className="pl-0" md={12} lg={6}>
          <img
            src={image2}
            alt=""
            style={{ width: "12vw", transform: "translateY(-6px)" }}
          />
        </Col>
        <Col md={12} lg={6} className="pr-0 text-right">
          <img src={image1} alt="" style={{ width: "10vw" }} />
        </Col>
      </Row>
    </Container>
  );
};

export default SidePanel;
